import {
  FETCH_LANDING_PAGE_CARDS,
  FETCH_MODULE_ID_DATA,
  GET_MODULES_LIST,
  GET_SELECTED_SEGMENT_DETAILS,
  GET_SOURCE_LIST,
  GET_HOME_PAGE_METADATA,
  GET_BUSINESS_QUESTION_POPUP_DATA,
  GET_USER_GUIDE,
  FETCH_ENHANCEMENT_POP_DATA,
  FETCH_FAVOURITE_LIST_DATA,
  FETCH_PRODUCT_FEATURE_LIST,
  FETCH_MARKET_MATURITY_DATA,
  FETCH_USER_PROFILE_DATA,
  FETCH_USER_CATEGORY_DATA,
  FETCH_ANNOUNCEMENTS_DATA,
  FETCH_RECENTLY_OPENED_DATA,
  FETCH_SEARCH_RESULTS
} from '../../../../constants';
import { axios } from '../../../../lib';
import {
  ISkuObject2,
  ISkuObject3
} from '../../simulator/innovation/types/sku-popup-model';
import {
  Announcement,
  IPageListItem,
  IIdentifierObject,
  ILandingResponse,
  IQuickStartObject,
  IProductFeature,
  ReleaseNotesData,
  MarketMaturityResponse,
  IReleaseNotesData,
  MarketMaturityDetails
} from '../types/landing-api-response.model';
import apiResponseToCards from '../utils/api-utils';

// eslint-disable-next-line import/prefer-default-export
export function fetchLandingPageCards() {
  return axios
    .get<ILandingResponse>(FETCH_LANDING_PAGE_CARDS)
    .then((response) => apiResponseToCards(response.data));
}

export function fetchSourceList() {
  return axios
    .get<{ data: ISkuObject2[] }>(GET_SOURCE_LIST)
    .then((response) => response.data);
}

// CALL FOR HOMEPAGE META DATA
export function fetchHomePageMetaData(sourceID) {
  return axios
    .get(`${GET_HOME_PAGE_METADATA}${sourceID}/`)
    .then((response) => response.data);
}

// api call for Business Question popUp component
export function fetchBusinessQuestionPopupData(sourceID) {
  return axios
    .post<{ data: ISkuObject3[] }>(
      `${GET_BUSINESS_QUESTION_POPUP_DATA}${sourceID}/`
    )
    .then((response) => response.data);
}

export function fetchModulesList() {
  return axios
    .get<{ data: ISkuObject2[] }>(GET_MODULES_LIST)
    .then((response) => response.data);
}

export function fetchSelectedSegmentInfo(sourceID) {
  return axios
    .get(`${GET_SELECTED_SEGMENT_DETAILS}${sourceID}/`)
    .then((response) => response.data);
}

// generic handler for fetching document, using url, filename and file extension
export function fetchDocument({ url, fileName, fileExtension }) {
  return axios
    .get<any>(url, {
      responseType: 'blob'
    })
    .then((res) => {
      const fileURL = window.URL.createObjectURL(res.data);
      const link = document.createElement('a');
      link.href = fileURL;
      link.download = fileName + fileExtension;
      link.click();

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(fileURL);
      return {
        data: 'Success'
      };
    });
}

// api for fetching module id data
export function fetchModuleIDData() {
  return axios.get(`${FETCH_MODULE_ID_DATA}`).then((response) => response.data);
}

// api for marking reports favorite
export function toggleFavoriteItem(args: {
  identifier: string;
  identifier_pk_id: string;
  is_favourite: boolean;
  sourceID: number;
}) {
  return axios
    .post<{ data: IPageListItem[]; identifier: IIdentifierObject }>(
      `${FETCH_FAVOURITE_LIST_DATA}${args.sourceID}/`,
      {
        identifier: args.identifier,
        identifier_pk_id: args.identifier_pk_id,
        is_favourite: args.is_favourite
      }
    )
    .then((response) => response.data);
}

// api for fetching favorite list
export function fetchFavoriteList(sourceID) {
  return axios
    .get<{ data: IPageListItem[]; identifier: IIdentifierObject }>(
      `${FETCH_FAVOURITE_LIST_DATA}${sourceID}/`
    )
    .then((response) => response);
}

// api for recording recently opened reports
export function recordRecentlyOpenedReport(args: {
  identifier: string;
  identifier_pk_id: string;
  sourceID: number;
}) {
  return axios
    .post(`${FETCH_RECENTLY_OPENED_DATA}${args.sourceID}/`, {
      identifier: args.identifier,
      identifier_pk_id: args.identifier_pk_id
    })
    .then((response) => response.data);
}

// api for fetching announcments list
export function fetchAnnouncementMapping(sourceID) {
  return axios
    .get(`${FETCH_ANNOUNCEMENTS_DATA}${sourceID}/`)
    .then((response) => response.data);
}

// api for fetching recently opened list
export function fetchRecentlyOpenedList(sourceID) {
  return axios
    .get<{ data: any[] }>(`${FETCH_RECENTLY_OPENED_DATA}${sourceID}/`)
    .then((response) => response.data);
}
// api for fetching user profile data
export function fetchQuickStartUserProfileData(sourceID) {
  return axios
    .get<IQuickStartObject[]>(`${FETCH_USER_PROFILE_DATA}${sourceID}/`)
    .then((response) => response.data);
}

export function fetchReleaseNotesData(sourceID) {
  return axios
    .post(`${FETCH_PRODUCT_FEATURE_LIST}${sourceID}/`)
    .then((response) => response.data);
}

export function fetchMarketMaturity(sourceID) {
  return axios
    .get(`${FETCH_MARKET_MATURITY_DATA}${sourceID}/`)
    .then((response) => response.data);
}

// api for fetching user category data
export function fetchQuickStartUserCategoryData(sourceID) {
  return axios.get(`${FETCH_USER_CATEGORY_DATA}${sourceID}/`);
}

// api for fetching feature/enhancement popup data
export function fetchEnhancementPopupData(versionNumber: any, sourceID: any) {
  return axios
    .post(`${FETCH_ENHANCEMENT_POP_DATA}${sourceID}/`, {
      version: versionNumber
    })
    .then((response) => response.data);
  // return Promise.resolve(featuresDummy);
}

// api for fetching serch results
export function fetchSearchResults(sourceID: number) {
  return axios
    .post(`${FETCH_SEARCH_RESULTS}${sourceID}/`)
    .then((response) => response);
}

export function fetchMarketMaturityTableData() {
  return [];
}
